/** 대분류명이 가점 사항(가점)인지 */
export const IsBonusCategoryLabel = (label) => {
  const compact = String(label ?? '').replace(/\s+/g, '');
  return compact.includes('가점');
};

/** steps 기준 가점 대분류 val1 집합 (예: "9") */
export const GetBonusVal1Set = (steps = []) =>
  new Set(
    (steps || [])
      .map((step, idx) => ({ step, val1: String(idx + 1) }))
      .filter(({ step }) => IsBonusCategoryLabel(step?.label))
      .map(({ val1 }) => val1)
  );

export const IsBonusVal1 = (val1, steps) =>
  GetBonusVal1Set(steps).has(String(val1));

/** 평가지표 배점(val2) 합 */
export const SumIndicatorVal2 = (
  arrayList,
  steps,
  { excludeBonus = false } = {}
) => {
  const bonusSet = excludeBonus ? GetBonusVal1Set(steps) : new Set();
  return (arrayList || [])
    .filter((row) => !bonusSet.has(String(row.val1)))
    .reduce((sum, row) => sum + Number(row.val2 || 0), 0);
};

/** 평가지표 취득(val3) 합 */
export const SumIndicatorVal3 = (
  arrayList,
  steps,
  { excludeBonus = false, onlyBonus = false } = {}
) => {
  const bonusSet = GetBonusVal1Set(steps);
  return (arrayList || [])
    .filter((row) => {
      const isBonus = bonusSet.has(String(row.val1));
      if (onlyBonus) return isBonus;
      if (excludeBonus) return !isBonus;
      return true;
    })
    .reduce((sum, row) => sum + Number(row.val3 || 0), 0);
};

/** 양식 저장용 기준 총점 — 가점 대분류 제외 */
export const CalcCategoryTotalForTemplate = (
  steps,
  arrayList,
  categoryMaxScore = 100
) =>
  (steps || []).reduce((sum, step, idx) => {
    if (IsBonusCategoryLabel(step?.label)) return sum;
    const catNo = String(idx + 1);
    const catScore = (arrayList || [])
      .filter((ind) => String(ind.val1) === catNo)
      .reduce((s, ind) => s + Number(ind.val2 || 0), 0);
    return sum + Math.min(catScore, categoryMaxScore);
  }, 0);
